// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoMessageOutlinedSvg from "@fishx/icons-svg/es/asn/PtoMessageOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoMessageOutlined = function PtoMessageOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoMessageOutlinedSvg
  }));
};

PtoMessageOutlined.displayName = 'PtoMessageOutlined';
export default React.forwardRef(PtoMessageOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoMessageOutlined.js
// module id = 3922
// module chunks = 0